import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createTtv,
  deleteTtvById,
  getTtvById,
  getTtvList,
  updateTtvById,
} from "./queries";

const TtvContext = createContext({});

export const useTtvContext = () => useContext(TtvContext);

export const TtvProvider = ({ ...props }) => {
  const [ttvList, setTtvList] = useState([]);
  const [ttvPerId, setTtvPerId] = useState({});

  const ttvListGetter = useCallback(async () => {
    try {
      if (ttvList.length === 0) {
        setTtvList(await getTtvList());
      }
    } catch (e) {
      console.error("ttvListGetter", e);
      throw e;
    }
  }, [ttvList]);
  const ttvByIdGetter = useCallback(
    async (id) => {
      try {
        setTtvPerId(await getTtvById(id));
      } catch (e) {
        console.error("ttvListGetter", e);
        throw e;
      }
    },
    [setTtvPerId]
  );
  const ttvCreate = useCallback(async (data) => {
    try {
      const ttv = await createTtv(data);
      setTtvList((old) => [...old, ttv]);
    } catch (e) {
      console.error("ttvCreate", e);
      throw e;
    }
  }, []);
  const ttvUpdateById = useCallback(async (id, data) => {
    try {
      const ttvUpdated = await updateTtvById(id, data);
      setTtvList((old) =>
        old.map((elm) => (elm.id === ttvUpdated.id ? ttvUpdated : elm))
      );
      setTtvPerId(ttvUpdated);
    } catch (e) {
      console.error("ttvUpdateById", e);
      throw e;
    }
  }, []);

  const ttvDeleteById = useCallback(
    async (id) => {
      try {
        await deleteTtvById(id);
        setTtvList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("ttvDelete", e);
        throw e;
      }
    },
    [setTtvList]
  );
  const values = useMemo(
    () => ({
      ttvList,
      ttvListGetter,
      ttvByIdGetter,
      ttvDeleteById,
      ttvCreate,
      ttvUpdateById,
      ttvPerId,
      setTtvPerId,
    }),
    [
      ttvList,
      ttvListGetter,
      ttvByIdGetter,
      ttvDeleteById,
      ttvCreate,
      ttvUpdateById,
      ttvPerId,
      setTtvPerId,
    ]
  );
  return <TtvContext.Provider value={values} {...props} />;
};
